/* eslint-disable @typescript-eslint/camelcase */
import { CustomLabelsState, TermsAndConditionsType } from '../types';

const en: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'This space should contain the relevant information for the stakeholders regarding the usage of the portal.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Grievances portal',
    homePageText:
        '<p>Welcome to the grievances portal.</p>		<p>Using this secure and confidential platform, you can send us your grievance, request for information or suggestion, anonymously or not. You can then follow up on your concern.</p>		<p>Whether you choose to submit a complaint anonymously or not, rest assured that each submission will be treated confidentially and promptly.</p>',
    createGrievanceTitle: 'File a grievance',
    createGrievanceText:
        'Please enter the details of your concern. Be as specific as possible. If applicable, include the following: date, location, important details, and people involved. Add photos if you have any. If you would like to receive a follow-up, please provide your contact details in the appropriate section.',
    footerText:
        'If you prefer to talk to someone for any reason, you can call us at 819-555-5555. The opening hours are the following:<br/>			Monday to Friday from 8 AM to 5 PM, Eastern time zone (Montreal)<br/>			Outside these hours you can leave a message and someone will contact you.',
    grievanceFollowUpAuthor: 'System',
    addFollowUpModalInfo: 'Use this field only if you require clarification or support for your request',
    accessGrievanceBtn: 'Access a grievance',
    accessGrievanceTitle: 'Access a grievance',
    accessGrievanceInfo: 'Please enter your grievance number and password to follow up.',
    grievanceRefNo: 'Grievance number',
    originalGrievance: 'Original grievance',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Enter your grievance number...',
    forgotPasswordGrievanceText:
        'Please enter your grievance number and email address\n        that was used during creation. If you have created your\n        grievance anonymously or did not provide your email\n        address, please contact our customer service.',
    grievanceDescriptionPlaceholder: 'Grievance details...',
    detailsPlaceholder: 'Details...',
    grievanceConfirmSuccessText: 'Your grievance was successfully submitted.',
    grievanceConfirmInfoText: 'If you want to follow up on the grievance you just sent, please create a password',
    grievanceConfirmSubmitPasswordSuccessText:
        'Your password was successfully created, to follow up on your grievance go to the verify page',
    grievanceConfirmFollowUp: 'Follow up on grievance',
    viewInitialGrievance: 'View initial grievance',
    viewGrievance: 'View grievance',
    claimant: 'Claimant',
};

const fr: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        "Cet espace devrait contenir les informations pertinentes pour les parties prenantes concernant l'utilisation du portail.",
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portail de plaintes',
    homePageText:
        '<p>Bienvenue sur le portail des plaintes.</p>\n\t\t<p>À l’aide de cette plateforme sécuritaire et confidentielle, vous pouvez nous transmettre votre plainte, demande d’information ou suggestion, et ce, de façon anonyme ou non. Vous pourrez ensuite faire le suivi de votre préoccupation.</p>\n\t\t<p>Que vous choisissiez de soumettre une plainte de façon anonyme ou non, soyez assuré(e) que chaque soumission sera traitée de façon confidentielle et dans les meilleurs délais.</p>',
    createGrievanceTitle: 'Formuler une plainte',
    createGrievanceText:
        'Veuillez entrer les détails de votre plainte. Soyez le plus précis possible. S’il y a lieu, incluez le ou les éléments suivants : la date, les éléments importants, le lieu et les personnes impliquées. Ajoutez des photos si vous en avez. Si vous souhaitez recevoir un suivi, veuillez fournir vos coordonnées dans la section appropriée.',
    footerText:
        "Si vous préférez parler à quelqu'un, vous pouvez composer le 819-555-5555. Les heures d'ouverture sont:</br>\n\t\tLundi au vendredi de 8:00 à 17:00 heure de l'est (Montreal)</br>\n\t\tEn-dehors de ces heures vous pouvez laisser un message et quelqu'un vous contactera.",
    grievanceFollowUpAuthor: 'Système',
    addFollowUpModalInfo:
        "Utilisez ce champ uniquement si vous avez besoin d'éclaircissements ou de support pour votre demande",
    accessGrievanceTitle: 'Accéder à une plainte',
    grievanceRefNo: 'Numéro de la plainte',
    accessGrievanceInfo: 'Veuillez entrer votre numéro de plainte et votre mot de passe pour faire le suivi.',
    accessGrievanceBtn: 'Accéder à une plainte',
    viewGrievance: 'Voir la plainte',
    viewInitialGrievance: 'Voir la plainte initiale',
    originalGrievance: 'Plainte initiale',
    grievanceNumberPlaceholder: 'Entrez votre numéro de plainte...',
    grievanceDescriptionPlaceholder: 'Détail de la plainte...',
    detailsPlaceholder: 'Détails...',
    forgotPasswordGrievanceText:
        "Veuillez entrer votre numéro de plainte ainsi que l'adresse courriel\n         qui a été utilisée lors de la création. Si vous avez créé votre\n       plainte de façon anonyme ou n'avez pas fourni votre adresse\n      courriel, veuillez contacter notre service à la clientèle.",
    grievanceConfirmSuccessText: 'Votre plainte a été soumise avec succès.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Votre mot de passe a été créé avec succès, pour donner suite à votre demande, allez sur la page de vérification',
    grievanceConfirmFollowUp: 'Faire un suivi de la plainte',
    grievanceConfirmInfoText:
        "Si vous souhaitez donner suite à la plainte que vous venez d'envoyer, veuillez créer un mot de passe",
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Demandeur',
};

const es: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Este espacio debe contener la información relevante para las partes interesadas con respecto al uso del portal.',

    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal de quejas',

    homePageText:
        '<p>Bienvenido al portal de quejas</p>\n\t\t<p>Usando esta plataforma segura y confidencial, puede enviarnos su queja, solicitud de información o sugerencia, ya sea de forma anónima o no. Luego, puede hacer un seguimiento de su inquietud.</p>\n\t\t<p>Ya sea que envíe una queja de forma anónima o no, tenga la seguridad de que cada solicitud se tratará de forma confidencial y rápida.</p>',
    createGrievanceTitle: 'Ingresar una solicitud',
    createGrievanceText:
        'Ingrese los detalles de su solicitud. Sea lo más específico posible. Incluya el(los) siguiente(s) elemento(s): fecha, elementos importantes, ubicación y personas involucradas. Agregue fotos si tiene alguna. Si desea recibir un seguimiento, proporcione sus datos de contacto en la sección correspondiente.',
    footerText:
        'Si prefiere hablar con alguno de nuestros representantes, puede llamarnos al 819-555-5555. Los horarios de atención son los siguientes:<br/>\n\t\t\tLunes a viernes de 8 a.m. a 5 p.m., Zona horaria del este (Montreal) <br/>\n\t\t\tFuera de ese horario puede dejar un mensaje y nos pondremos en contacto con usted lo antes posible.',
    grievanceFollowUpAuthor: 'Sistema',
    addFollowUpModalInfo:
        'Utilizar este campo sólo si requiere realizar aclaraciones o nuevos soportes para su solicitud',
    accessGrievanceTitle: 'Acceder a una solicitud',
    grievanceRefNo: 'Número de solicitud',
    accessGrievanceInfo: 'Ingrese su número de solicitud y contraseña para realizar el seguimiento.',
    accessGrievanceBtn: 'Acceder a una solicitud',
    viewGrievance: 'Ver solicitud',
    viewInitialGrievance: 'Ver solicitud inicial',
    originalGrievance: 'Solicitud original',
    grievanceNumberPlaceholder: 'Ingrese el número de solicitud...',
    grievanceDescriptionPlaceholder: 'Detalles de la solicitud...',
    detailsPlaceholder: 'Detalles...',
    forgotPasswordGrievanceText:
        'Por favor ingrese su número de solicitud y dirección de correo electrónico usados durante la creación.\n        Si ha creado la solicitud de forma anónima o no proporcionó su dirección correo electrónico,\n        póngase en contacto con nuestro servicio al cliente.',
    grievanceConfirmSuccessText: 'Su solicitud se envió correctamente.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Su contraseña se creó correctamente, para seguir su solicitud, vaya a la página de verificación',
    grievanceConfirmFollowUp: 'Seguimiento a pedido',
    grievanceConfirmInfoText:
        'Si desea hacer un seguimiento a la solicitud que acaba de enviar, por favor cree una contraseña',
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Solicitante',
};

const pt: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Este espaço deve conter as informações relevantes para os stakeholders a respeito do uso do portal.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal de reclamações',
    homePageText:
        '<p> Bem-vindo(a) ao portal de reclamações.</p>		<p> Utilizando esta plataforma segura e confidencial, você pode nos enviar sua reclamação, dúvida ou sugestão, de forma anônima ou não. Em seguida, você pode acompanhar sua solicitação. p>		<p> Tenha certeza de que cada envio será tratado de forma confidencial e rápida, mesmo se você optar por enviar uma reclamação anonimamente ou não.</p>',
    createGrievanceTitle: 'Enviar uma reclamação',
    createGrievanceText:
        ' Por favor, insira os detalhes da sua reclamação. Seja o mais específico possível. Se aplicável, inclua as informações seguintes: data, local, detalhes importantes e pessoas envolvidas. Caso tenha alguma(s) foto(s), você também pode adicioná-la(s). Se você deseja receber um acompanhamento da sua reclamação, forneça seus detalhes de contato na seção apropriada.',
    footerText:
        'Caso prefira falar com alguém por qualquer motivo, você pode nos ligar no +1 819-555-5555. O horário de funcionamento é o seguinte:<br/>			De segunda a sexta das 8h às 17h, horário de Montreal<br/>			Fora desse horário você pode nos deixar uma mensagem e alguém entrará em contato com você.',
    grievanceFollowUpAuthor: 'Sistema',
    addFollowUpModalInfo: 'Use este campo apenas se você precisar de esclarecimentos ou suporte para sua solicitação',
    accessGrievanceBtn: 'Acessar uma reclamação',
    accessGrievanceTitle: 'Acessar uma reclamação',
    accessGrievanceInfo: ' Por favor, insira o número da reclamação e a sua senha para acompanhar a sua solicitação.',
    grievanceRefNo: 'Número da reclamação',
    originalGrievance: 'Reclamação original',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Digite o número da sua reclamação...',
    forgotPasswordGrievanceText:
        ' Digite o número da reclamação e o endereço de e-mail \n        que foi usado durante a criação da sua reclamação. Se você criou a sua \n        reclamação anonimamente ou não forneceu seu endereço de \n        e-mail, entre em contato com o nosso serviço ao cliente.',
    grievanceDescriptionPlaceholder: 'Detalhes da reclamação...',
    detailsPlaceholder: 'Detalhes...',
    grievanceConfirmSuccessText: 'Sua reclamação foi enviada com sucesso.',
    grievanceConfirmInfoText: 'Se você deseja acompanhar a reclamação que acabou de enviar, crie uma senha',
    grievanceConfirmSubmitPasswordSuccessText:
        'Sua senha foi criada com sucesso. Para acompanhar sua reclamação vá para a página de verificação',
    grievanceConfirmFollowUp: 'Acompanhar reclamação',
    viewInitialGrievance: 'Ver reclamação inicial',
    viewGrievance: 'Ver reclamação',
    claimant: 'Requerente',
};

const ar: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'يجب أن تحتوي هذه المساحة على المعلومات ذات الصلة لأصحاب المصلحة فيما يتعلق باستخدام البوابة.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'بوابة الشكاوى',
    homePageText:
        '<p> مرحبا بك في بوابة الشكاوى.</p>		<p> باستخدام هذا النظام الأساسي الآمن والسري ، يمكنك إرسال شكواك إلينا أو طلب معلومات أو اقتراح ، سواء أكان ذلك مجهولاً أم لا. يمكنك بعد ذلك متابعة ما يقلقك.</p>		<p> سواء اخترت تقديم شكوى دون الكشف عن هويتك أم لا ، كن مطمئنًا إلى أن كل إرسال سيتم التعامل معه بسرية وفورية.</p>',
    createGrievanceTitle: 'قدم شكوى',
    createGrievanceText:
        ' الرجاء إدخال تفاصيل قلقك. أن تكون محددة قدر الإمكان. إن أمكن ، قم بتضمين ما يلي: التاريخ والموقع والتفاصيل المهمة والأشخاص المعنيين. أضف الصور إذا كان لديك أي منها. إذا كنت ترغب في تلقي متابعة ، يرجى تقديم تفاصيل الاتصال الخاصة بك في القسم المناسب.',
    footerText:
        'إذا كنت تفضل التحدث إلى شخص ما لأي سبب ، يمكنك الاتصال بنا على 5555-555-819. ساعات العمل هي كما يلي:<br/>			من الاثنين إلى الجمعة من الساعة 8 صباحًا حتى 5 مساءً ، المنطقة الزمنية الشرقية (مونتريال)<br/>			خارج هذه الساعات يمكنك ترك رسالة وسيتصل بك شخص ما.',
    grievanceFollowUpAuthor: ' نظام',
    addFollowUpModalInfo: 'استخدم هذا الحقل فقط إذا كنت تحتاج إلى توضيح أو دعم لطلبك',
    accessGrievanceBtn: 'الوصول إلى شكوى',
    accessGrievanceTitle: 'الوصول إلى شكوى',
    accessGrievanceInfo: ' الرجاء إدخال رقم الشكوى وكلمة المرور للمتابعة.',
    grievanceRefNo: 'رقم الشكوى ',
    originalGrievance: 'الشكوى الأصلية',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'أدخل رقم شكواك ...',
    forgotPasswordGrievanceText:
        'الرجاء إدخال رقم الشكوى وعنوان البريد الإلكتروني الخاص بك \n        التي تم استخدامها أثناء الإنشاء. إذا قمت بإنشاء ملف \n        شكوى مجهولة أو لم تقدم عنوانك \n        البريد الإلكتروني ، يرجى الاتصال بخدمة العملاء.',
    grievanceDescriptionPlaceholder: 'تفاصيل الشكوى ...',
    detailsPlaceholder: 'تفاصيل...',
    grievanceConfirmSuccessText: 'تم تقديم شكواك بنجاح.',
    grievanceConfirmInfoText: ' إذا كنت ترغب في متابعة الشكوى التي أرسلتها للتو ، يرجى إنشاء كلمة مرور',
    grievanceConfirmSubmitPasswordSuccessText:
        'تم إنشاء كلمة المرور الخاصة بك بنجاح ، لمتابعة شكواك ، انتقل إلى صفحة التحقق',
    grievanceConfirmFollowUp: 'متابعة الشكوى',
    viewInitialGrievance: 'عرض الشكوى الأولية',
    viewGrievance: 'عرض الشكوى',
    claimant: ' المدعي ',
};

const fi: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText: 'Tämän tilan olisi sisällettävä sidosryhmille tärkeitä tietoja portaalin käytöstä.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Kantelujen portaali',
    homePageText:
        '<p>Tervetuloa kanteluportaaliin.</p>		<p>Tämän suojatun ja luottamuksellisen foorumin kautta voit lähettää meille valituksesi, tietopyyntösi tai ehdotuksesi nimettömänä tai ilman. Voit sitten seurata huolenaiheesi käsittelyä.</p>		<p>Riippumatta siitä, haluatko tehdä valituksen nimettömänä vai et, voit olla varma, että jokainen valitus käsitellään luottamuksellisesti ja viipymättä.</p>',
    createGrievanceTitle: 'Tee valitus',
    createGrievanceText:
        'Kirjoita huolenaiheesi yksityiskohdat. Ole mahdollisimman tarkka.Ilmoita tarvittaessa seuraavat tiedot: päivämäärä, paikka, tärkeät yksityiskohdat ja osallistuneet henkilöt. Lisää valokuvia, jos sinulla on sellaisia. Jos haluat saada jatkotoimia, anna yhteystietosi asianmukaiseen kohtaan.',
    footerText:
        'Jos haluat jostain syystä puhua jonkun kanssa, voit soittaa meille numeroon 819-555-5555. Aukioloajat ovat seuraavat:<br/>			Maanantaista perjantaihin klo 8-17, itäinen aikavyöhyke (Montreal).<br/>			Näiden aikojen ulkopuolella voit jättää viestin ja joku ottaa sinuun yhteyttä.',
    grievanceFollowUpAuthor: 'Järjestelmä',
    addFollowUpModalInfo: 'Käytä tätä kenttää vain, jos tarvitset selvennystä tai tukea pyyntöösi.',
    accessGrievanceBtn: 'Pääsy kanteluun',
    accessGrievanceTitle: 'Pääsy kanteluun',
    accessGrievanceInfo: 'Kirjoita valituksen numero ja salasana jatkotoimia varten.',
    grievanceRefNo: 'Palautteen numero',
    originalGrievance: 'Alkuperäinen kantelu',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Syötä valituksesi numero...',
    forgotPasswordGrievanceText:
        'Anna valituksen numero ja sähköpostiosoite.\n        jota käytettiin luomisen aikana. Jos olet luonut\n        valituksen nimettömänä tai et ole antanut osoitettasi\n        sähköpostiosoitetta, ota yhteyttä asiakaspalveluumme.',
    grievanceDescriptionPlaceholder: 'Valituksen yksityiskohdat...',
    detailsPlaceholder: 'Yksityiskohdat...',
    grievanceConfirmSuccessText: 'Kantelusi on toimitettu onnistuneesti.',
    grievanceConfirmInfoText: 'Jos haluat seurata juuri lähettämääsi valitusta, luo salasana.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Salasanasi luotiin onnistuneesti, voit seurata valitustasi siirtyäksesi vahvistussivulle',
    grievanceConfirmFollowUp: 'Valituksen seuranta',
    viewInitialGrievance: 'Alkuperäisen valituksen tarkastelu',
    viewGrievance: 'Näytä valitus',
    claimant: 'Hakija',
};

const sv: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Detta utrymme bör innehålla relevant information för intressenterna om hur portalen används.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal för klagomål',
    homePageText:
        '<p>Välkommen till portalen för klagomål.</p>		<p>Via denna säkra och konfidentiella plattform kan du skicka oss ditt klagomål, din begäran om information eller ditt förslag, anonymt eller inte. Du kan sedan följa upp ditt ärende.</p>		<p>Oavsett om du väljer att lämna in ett klagomål anonymt eller inte kan du vara säker på att varje klagomål behandlas konfidentiellt och snabbt.</p>',
    createGrievanceTitle: 'Lämna in ett klagomål',
    createGrievanceText:
        'Ange detaljerna om ditt ärende. Var så specifik som möjligt. Ange i förekommande fall följande: datum, plats, viktiga uppgifter och berörda personer. Lägg till foton om du har några. Om du vill få en uppföljning, vänligen ange dina kontaktuppgifter i det aktuella avsnittet.',
    footerText:
        'Om du föredrar att prata med någon av någon anledning kan du ringa oss på 819-555-5555. Öppettiderna är följande:<br/>			Måndag till fredag kl. 8-17, östlig tidszon (Montreal)<br/>			Utanför dessa tider kan du lämna ett meddelande och någon kommer att kontakta dig.',
    grievanceFollowUpAuthor: 'System',
    addFollowUpModalInfo: 'Använd det här fältet endast om du behöver ett förtydligande eller stöd för din begäran.',
    accessGrievanceBtn: 'Få tillgång till ett klagomål',
    accessGrievanceTitle: 'Få tillgång till ett klagomål',
    accessGrievanceInfo: 'Ange ditt klagomålsnummer och lösenord för att följa upp det.',
    grievanceRefNo: 'Ärendenummer',
    originalGrievance: 'Ursprungligt klagomål',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Ange ditt klagomålsnummer...',
    forgotPasswordGrievanceText:
        ' Ange ditt klagomålsnummer och din e-postadress\n             som användes vid skapandet. Om du har skapat din\n            klagomål anonymt eller om du inte har angett din adress\n         e-postadress, vänligen kontakta vår kundtjänst.',
    grievanceDescriptionPlaceholder: 'Uppgifter om klagomål...',
    detailsPlaceholder: 'Detaljer...',
    grievanceConfirmSuccessText: 'Ditt klagomål har skickats in',
    grievanceConfirmInfoText: 'Om du vill följa upp det klagomål som du just skickade, skapa ett lösenord',
    grievanceConfirmSubmitPasswordSuccessText:
        'Ditt lösenord har skapats, för att följa upp ditt klagomål går du till sidan Verifiera',
    grievanceConfirmFollowUp: 'Uppföljning av klagomål',
    viewInitialGrievance: 'Visa det ursprungliga klagomålet',
    viewGrievance: 'Visa klagomål',
    claimant: 'Sökande',
};

const ja: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText: 'このスペースには、ポータルの利用方法に関する利害関係者のための関連情報を記載する。',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: '苦情処理ポータル',
    homePageText:
        '<p>苦情処理ポータルへようこそ。</p>		<p>この安全で機密性の高いプラットフォームを使用すると、匿名かどうかにかかわらず、苦情、情報要求、または提案を送ることができます。その後、あなたの懸念についてフォローアップすることができます。</p>		<p>匿名で苦情を提出するかどうかにかかわらず、提出された苦情は機密扱いで迅速に処理されますのでご安心ください。</p>',
    createGrievanceTitle: '苦情を申し立てる',
    createGrievanceText:
        'お気づきの点を詳しくご記入ください。できるだけ具体的に記入してください。該当する場合は、日付、場所、重要な内容、関係者などを記入してください。写真があれば追加してください。フォローアップを希望される場合は、該当する欄に連絡先をご記入ください。',
    footerText:
        'お電話でのお問い合わせは、819-555-5555までご連絡ください。営業時間は以下の通りです：<br/>			月～金：午前8時～午後5時、東部時間帯（モントリオール）<br/>			時間外でもメッセージを残していただければ、担当者がご連絡いたします。',
    grievanceFollowUpAuthor: 'システム',
    addFollowUpModalInfo: 'このフィールドは、リクエストに関する説明やサポートが必要な場合にのみ使用してください。',
    accessGrievanceBtn: '苦情処理へのアクセス',
    accessGrievanceTitle: '苦情処理へのアクセス',
    accessGrievanceInfo: '苦情処理番号とパスワードを入力してください。',
    grievanceRefNo: '苦情処理番号',
    originalGrievance: '元の苦情',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: '苦情処理番号を入力してください。',
    forgotPasswordGrievanceText:
        '苦情処理番号とEメールアドレスを入力してください。\n        作成時に使用されたものです。もし\n        匿名で苦情を申し立てた場合、または電子メールを提供しなかった場合\n        の住所までご連絡ください。',
    grievanceDescriptionPlaceholder: '苦情の詳細...',
    detailsPlaceholder: '詳細...',
    grievanceConfirmSuccessText: '苦情は正常に提出されました。',
    grievanceConfirmInfoText: '送信した苦情に対するフォローアップを希望される場合は、パスワードを作成してください。',
    grievanceConfirmSubmitPasswordSuccessText:
        'パスワードが正常に作成されました。苦情のフォローアップを行うには、確認ページに移動してください。',
    grievanceConfirmFollowUp: '苦情のフォローアップ',
    viewInitialGrievance: '最初の苦情を見る',
    viewGrievance: '苦情を表示',
    claimant: 'クレーム主',
};

const de: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Dieser Bereich sollte die relevanten Informationen für die Teilnehmer über die Nutzung des Portals enthalten.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal für Beschwerden',
    homePageText:
        '<p>Willkommen im Beschwerdeportal.</p>		<p>Über diese sichere und vertrauliche Plattform können Sie uns Ihre Beschwerde, Ihr Ersuchen um Informationen oder Ihre Anregungen übermitteln - anonym oder nicht. Sie können Ihr Anliegen dann weiterverfolgen.</p>		<p>Unabhängig davon, ob Sie eine Beschwerde anonym einreichen oder nicht, können Sie sicher sein, dass jede Beschwerde vertraulich und umgehend behandelt wird.</p>',
    createGrievanceTitle: 'Beschwerde einreichen',
    createGrievanceText:
        'Bitte geben Sie die Details zu Ihren Bedenken an. Seien Sie so genau wie möglich. Geben Sie alle betreffenden Daten, Orte, wichtige Details und Namen der beteiligten Personen an. Fügen Sie bei Bedarf Fotos hinzu. Wenn Sie weitere Informationen erhalten möchten, tragen Sie bitte Ihre Kontaktdaten in den entsprechenden Abschnitt ein.',
    footerText:
        'Wenn Sie lieber mit einem Vertreter sprechen möchten, rufen Sie 819-555-5555 an. Unsere Geschäftszeiten sind <br/>			Montag bis Freitag von 8 Uhr bis 17 Uhr Eastern Time (Montreal).<br/>			Außerhalb dieser Zeiten können Sie eine Nachricht hinterlassen und jemand wird Sie zurückrufen.',
    grievanceFollowUpAuthor: 'System',
    addFollowUpModalInfo:
        'Verwenden Sie dieses Feld nur, wenn Sie Klärung oder Unterstützung im Zusammenhang mit Ihrer Anfrage benötigen',
    accessGrievanceBtn: 'Beschwerdezugriff',
    accessGrievanceTitle: 'Beschwerdezugriff',
    accessGrievanceInfo:
        'Bitte geben Sie Ihre Beschwerde-Nummer und Ihr Passwort ein, um die Beschwerde zu bearbeiten.',
    grievanceRefNo: 'Beschwerde Nummer',
    originalGrievance: 'Ursprüngliche Beschwerde',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Geben Sie Ihre Beschwerdenummer ein...',
    forgotPasswordGrievanceText:
        'Bitte geben Sie Ihre Beschwerde-Nummer und E-Mail-Adresse ein\n        die während der Erstellung benutzt wurde. If you have created your\n        beschwerde anonymously or have not provided your e-mail\n        address, please contact our customer service.',
    grievanceDescriptionPlaceholder: 'Details zur Beschwerde...',
    detailsPlaceholder: 'Einzelheiten...',
    grievanceConfirmSuccessText: 'Ihre Beschwerde wurde erfolgreich eingereicht.',
    grievanceConfirmInfoText:
        'Wenn Sie die soeben abgeschickte Beschwerde verfolgen möchten, erstellen Sie bitte ein Passwort',
    grievanceConfirmSubmitPasswordSuccessText:
        'Ihr Passwort wurde erfolgreich erstellt. Um Ihre Beschwerde zu verfolgen, gehen Sie auf die Bestätigungsseite',
    grievanceConfirmFollowUp: 'Weiterverfolgung der Beschwerde',
    viewInitialGrievance: 'Erste Beschwerde anzeigen',
    viewGrievance: 'Beschwerde ansehen',
    claimant: 'Antragsteller',
};

const DefaultLabels = {
    en,
    fr,
    es,
    pt,
    ar,
    fi,
    sv,
    ja,
    de,
};

export default DefaultLabels;
